import { LegalConfig } from '@vueling-ng/vy-ds/src/lib/components/composed/footer';
import { ListNavigationItem } from '@vueling-ng/vy-ds/src/lib/components/globals/list-navigation';

export const AgencyListNavigationCoreItem: ListNavigationItem[] = [
  {
    title: 'footer_component.legal.title_conditions_use',
    href: 'footer_component.legal.url_conditions_use',
    targetBlank: true
  },
  {
    title: 'footer_component.legal.title_cookie_policy',
    href: 'footer_component.legal.url_cookie_policy',
    targetBlank: true
  },
  {
    title: 'footer_component.legal.title_privacy_policy',
    href: 'footer_component.legal.url_privacy_policy',
    targetBlank: true
  },
  {
    title: 'footer_component.legal.title_transport_conditions',
    href: 'footer_component.legal.url_transport_conditions',
    targetBlank: true
  },
  {
    title: 'footer_component.legal.title_slavery_human_trafficking',
    href: 'footer_component.legal.url_slavery_human_trafficking',
    targetBlank: true
  }
];

export const extendedLegalConfig: LegalConfig = {
  footerLegalTitle: 'footer_component.copy_right',
  itemsLegalFooter: AgencyListNavigationCoreItem
};

export const AgencyListNavigationItem: ListNavigationItem[] = [
  ...AgencyListNavigationCoreItem,
  {
    title: 'footer_component.legal.title_legal_conditions',
    href: 'footer_component.legal.url_legal_agency_conditions',
    targetBlank: true
  }
];

export const CorporateListNavigationItem: ListNavigationItem[] = [
  ...AgencyListNavigationCoreItem,
  {
    title: 'footer_component.legal.title_legal_conditions_corporate',
    href: 'footer_component.legal.url_legal_corporate_conditions',
    targetBlank: true
  }
];
